import Axios from 'axios';
import { API_BASE_URL } from 'configs/apiUrl';

const axios = Axios.create({ baseURL: API_BASE_URL, timeout: 9000000 });

export default axios;
